import { getLivisUserInfo } from "../../helpers/storage";

/**
 * Reads the logged-in user's identity the same way src/helpers/finduser.ts
 * and the axios auth interceptor already do — straight from localStorage,
 * re-parsed on every call. No React hooks, so this can be called from plain
 * modules (the logger singleton, the axios interceptor, window error
 * handlers) that live outside any component tree.
 */
export const getCurrentUserIdentity = (): {
  email?: string;
  name?: string;
  is_superuser?: boolean;
} => {
  try {
    const raw = getLivisUserInfo();
    if (!raw) return {};
    const userInfo = JSON.parse(raw);
    const name = [userInfo?.first_name, userInfo?.last_name]
      .filter(Boolean)
      .join(" ")
      .trim();
    return {
      email: userInfo?.email || undefined,
      name: name || undefined,
      is_superuser: userInfo?.is_superuser,
    };
  } catch {
    return {};
  }
};
